import accounting from 'accounting'

export const symbols = {
  GBP: '£',
  EUR: '€',
  AUD: '$',
  USD: '$',
  CAD: '$'
}

export function getAvailableCredit (stockist) {
  let price = 0
  const currency = getCurrency(stockist?.country)

  if (stockist?.credit?.availableCredit) {
    price = stockist.credit.availableCredit
  }

  return displayPrice(price, currency)
}

export function getCreditLimit (stockist) {
  let price = 0
  const currency = getCurrency(stockist?.country)

  if (stockist?.credit?.creditLimit) {
    price = stockist.credit.creditLimit
  }

  return displayPrice(price, currency)
}

export function displayPrice (price, currency) {
  return accounting.formatMoney(price, symbols[currency] || '$')
}

export const getCurrency = (abv) => {
  let currency = 'EUR'

  switch (abv) {
    case 'GB':
      currency = 'GBP'
      break
    case 'US':
      currency = 'USD'
      break
    case 'CA':
      currency = 'CAD'
      break
    case 'AU':
      currency = 'AUD'
      break
  }

  return currency
}
